import React, { useState } from "react";
import CheckoutForm from "./CheckoutForm";
import { useNavigate } from 'react-router-dom';


const items = [
  { id: "price_1R9jAeJghU42dndgldb2W7Ca", image: "/mainImages/LSR-Aware-PC.png", price: "$ 10" },
  { id: "price_1R9jAYJghU42dndgzSP96dUZ", image: "/mainImages/LSR-Pro-PC.png", price: "$ 30" },
  { id: "price_1R9jAPJghU42dndgvedAAupQ", image: "/mainImages/LSR-Roads-PC.png", price: "$ 30"},

    { id: "price_1RGJDKJghU42dndguIHX6f98", image: "/bundleimages/bundleaware.png", price: "$ 65" },

  { id: "price_1R9jAGJghU42dndgh1ALXi3R", image: "/mainImages/Driving-Aware-All-Roads-PC.png", price: "$ 15" },
  { id: "price_1R9jA5JghU42dndgu8epBXKo", image: "/mainImages/DrivingPro-Black-Top-PC.png", price: "$ 25" },
  { id: "price_1R9j9yJghU42dndgG9etv8zj", image: "/mainImages/DrivingPro-Graded-Road-PC.png", price: "$ 30" },
  
  { id: "price_1RGJDHJghU42dndgYJcgnVLl", image: "/bundleimages/bundlepro.png", price: "$ 60" },

  { id: "price_1R9j9jJghU42dndgz4dlC055", image: "/bundleimages/processsafetylockout.png", price: " $ 50" },
  { id: "price_1RGJCgJghU42dndgk4Gus1fU", image: "/bundleimages/processafetygrey.png", price: "$ 0" },


];

const CheckoutPage = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const [totalPrice, setTotalPrice] = useState(0);

    const navigate = useNavigate();



 const handleSelect = (id, price) => {
    // Update selected items array
    if (id === 'price_1RGJCgJghU42dndgk4Gus1fU') {
    alert("Coming Soon! For more information, please contact info@virsatAcademy.com.");
    return; }
    
    setSelectedItems((prev) => {
      const updatedSelectedItems = prev.includes(id)
        ? prev.filter((item) => item !== id) 
        : [...prev, id]; 

      // Recalculate total price
      const newTotalPrice = updatedSelectedItems.reduce((total, selectedId) => {
        const item = items.find((item) => item.id === selectedId);
        return total + parseFloat(item.price.replace('$', '')); 
      }, 0);
    
    setTotalPrice(newTotalPrice);
    const selectedItemsWithQuantity = updatedSelectedItems.map((selectedId) => ({
      id: selectedId,
      quantity: 1 
    }));
    return updatedSelectedItems;

    });

  };

  const handlePurchase = () => {
     const selectedItemsWithQuantity = selectedItems.map((selectedId) => ({
      id: selectedId,
      quantity: 1
    }));
    navigate("/checkout", { state: { selectedItems: selectedItemsWithQuantity  } 
    
    });

   
  };

  return (
    <div className="checkout-main">
    <p className="module-title"> Purchase License</p>

    <div className="checkout-container-business">
      {items.map((item) => (

        <div key={item.id} className="item">
                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", marginTop: "10px" }}>

          <input 
            type="checkbox"
            onChange={() => handleSelect(item.id)}
            checked={selectedItems.includes(item.id)}

          />
          <img src={item.image} alt="game images" />
          </label>
          <div className={"description-box"}>
          
  {item.price}
        </div>
        </div>
        
      ))}
      </div>

      <div className="checkout-calculation">
        <div className="sub-cover-main">
        <div className="sub-checkout-main">
      <h1 className="checkout-h2">Total: ${totalPrice}</h1>
      <button className="body-button" onClick={handlePurchase}>
        Purchase
      </button>
      
      </div>
      </div>
       <div className="purchase-text-below-individual"> 
          <p> All PC licenses are valid for 30 days from the date of purchase and allows for 10 game run. Each pin verification at start of game counts as one game run.</p>
        </div>
      </div>

    </div>
  );
};

export default CheckoutPage;
